/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderStatusListResponse } from '../../models/order-status-list-response';

export interface CustomerOrderStatusControllerGetAll$Params {
}

export function customerOrderStatusControllerGetAll(http: HttpClient, rootUrl: string, params?: CustomerOrderStatusControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, customerOrderStatusControllerGetAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderStatusListResponse;
      }>;
    })
  );
}

customerOrderStatusControllerGetAll.PATH = '/order/customer-status';
